export class DocEmpresaGrouped{
    tipo: string;
    docEmpresaList : any[];
  }